import { getSystemHintsApi } from './configuration';

const systemHints = {
  getSystemHints: () => {
    return getSystemHintsApi().readStbGroupSystemHints();
  },
};

export default systemHints;
